import ApiPlugin from "@/api/base";

export default class ElementsTreeNode {
  constructor(obj){

    this.id = 0;
    this.hash = null;
    // this.depth = 0; пока бессмысленно
    this.isRoot = false;
    this.parentNode = null;

    this.loading = false;

    this.expanded = false;
    this.hasChildren = false;
    this.childrenToShow = [];
    this.childrenNodes = [];

    this.model = {};
    this.thisParentLink = null;
    this.otherParentsLinks = [];

    if( obj ){
      this.id = obj.id;
      this.hash = this.id.toString() + Math.floor(Math.random() * (9999 - 1 + 1) + 1).toString();
      this.model = obj;

      if( obj.has_children ){
        this.hasChildren = true;
      }

      // auto parse children from backend
      if( obj.children && obj.children.length ){
        obj.children.forEach(childData => {
          this.appendChildFromData(childData);
        })
        this.childrenToShow = this.childrenNodes;
        this.expanded = true;
      }
    }
  }

  loadChildren() {
    this.loading = true;
    return ApiPlugin.cascading.elementsGetByParentId({
      parent_id: this.id,
      expand: [
        'scale','has_children',
        'parent_links','parent_links.parent_element',
        'card', 'card.user',
        'permissions'
      ].join(),
    })
      .then(data => {
        if( !this.id && data.root_element ){
          this.isRoot = true;
          this.id = data.root_element.id;
          this.model = data.root_element;
        }
        this.childrenNodes = [];
        data.elements.forEach(element => {
          this.appendChildFromData(element);
        });
      })
      .finally(() => {
        this.loading = false;
      })
  }

  createChild(){
    this.loading = true;
    return ApiPlugin.cascading.elementCreate({
      parent_id: this.id,
    })
      .then(data => {
        const newChildNode = this.appendChildFromData(data.element);

        return this.expand()
          .then(() => {
            return newChildNode;
          })
      })
      .finally(() => {
        this.loading = false;
      })
  }

  appendChildFromData(childData){
    this.hasChildren = true;

    const childExists = this.childrenNodes.find(c => c.id === childData.id);
    if( childExists ){
      return childExists;
    }

    const newChildNode = new ElementsTreeNode(childData);
    // newChildNode.depth = this.depth + 1;
    newChildNode.parentNode = this;
    newChildNode.thisParentLink = childData.parent_links.find(l => l.parent_id === this.id);
    newChildNode.otherParentsLinks = childData.parent_links.filter(l => l.parent_id !== this.id);

    this.childrenNodes.push(newChildNode);

    return newChildNode;
  }

  save() {
    this.loading = true;
    return ApiPlugin.cascading.elementUpdate({
      ...this.model,
    })
      .then(data => {
        this.model = data.element;
        return this;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  saveParentLink(parentLink) {
    this.loading = true;
    return ApiPlugin.cascading.elementUpdateParentLink({
      parent_id: parentLink.parent_id,
      child_id: parentLink.child_id,
      weight: parentLink.weight,
      order: parentLink.order,
    })
      .then(data => {
      })
      .finally(() => {
        this.loading = false;
      })
  }

  assignToCard(cardId) {
    this.loading = true;
    return ApiPlugin.cascading.elementAssignToCard({
      element_id: this.model.id,
      card_id: cardId,
    })
      .then(data => {
      })
      .finally(() => {
        this.loading = false;
      })
  }

  runAutoCascading() {
    this.loading = true;
    return ApiPlugin.cascading.elementRunAutoCascading({
      element_id: this.model.id,
    })
      .then(data => {
      })
      .finally(() => {
        this.loading = false;
      })
  }

  unlink() {
    this.loading = true;
    return ApiPlugin.cascading.elementUnlink({
      element_id: this.id,
      parent_id: this.parentNode.id,
    })
      .then(data => {
        this.removeFromList();
      })
      .finally(() => {
        this.loading = false;
      })
  }
  delete() {
    this.loading = true;
    return ApiPlugin.cascading.elementDelete({
      id: this.id,
    })
      .then(data => {
        this.removeFromList();
      })
      .finally(() => {
        this.loading = false;
      })
  }

  removeFromList() {
    const deletedIndex = this.parentNode.childrenNodes.indexOf(this);
    if( deletedIndex !== -1 ){
      this.parentNode.childrenNodes.splice(deletedIndex, 1);
      if( !this.parentNode.childrenNodes.length ){
        this.parentNode.hideExpand();
        this.parentNode.hasChildren = false;
      }
    }
  }

  doDragAndDropAction(actionData){
    this.loading = true;
    return ApiPlugin.cascading.elementDoDragAndDropAction({
      element_id: this.id,
      action: actionData.action,
      old_parent_id: actionData.oldParentNodeId,
      new_parent_id: actionData.newParentNodeId,
      new_order: actionData.newOrder,
    })
      .then(data => {
      })
      .finally(() => {
        this.loading = false;
      })
  }

  toggleExpand(){
    if( this.expanded ){
      this.hideExpand();
    } else {
      this.expand();
    }
  }
  expand(){
    if( this.expanded ){
      return Promise.resolve();
    }
    return this.loadChildren()
      .then(() => {
        this.childrenToShow = this.childrenNodes;
        this.expanded = true;
      })
  }
  hideExpand(){
    this.expanded = false;
    this.childrenToShow = [];
  }


  isActionAllowed(actionName){
    const allowedPermissions = this.model?.permissions || [];
    return allowedPermissions.includes('action_' + actionName);
  }
  isFieldViewable(fieldName){
    const allowedPermissions = this.model?.permissions || [];
    return allowedPermissions.includes('view_' + fieldName);
  }
  isFieldEditable(fieldName){
    const allowedPermissions = this.model?.permissions || [];
    return allowedPermissions.includes('edit_' + fieldName);
  }

  getHiddenPlaceholder(field){
    if( this.model[field] === undefined ){
      return 'Скрыто';
    }

    return '';
  }

}